import { render, staticRenderFns } from "./multiuserAcceptAppBar.vue?vue&type=template&id=71a4f9a6"
import script from "./multiuserAcceptAppBar.vue?vue&type=script&lang=js"
export * from "./multiuserAcceptAppBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports